module.exports = __webpack_public_path__ + "fonts/abel.75e89759.ttf";